// src/pages/driverReports/carSheets/CarExpenses/loadSheet.js

import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../../../firebase/firebase";

/**
 * Load a car sheet ONLY from Firestore.
 * If Firestore has no sheet yet → create initial sheet ONCE.
 */
export async function loadSheetFromFirestore(month, sheet) {
  if (!month || !sheet?.id) throw new Error("Missing month or sheet.id");

  const ref = doc(db, "carSheets", month, "sheets", sheet.id);
  const snap = await getDoc(ref);

  if (snap.exists()) {
  const data = snap.data();
  return {
    ...data,
    id: sheet.id,
    incomeRows: data.incomeRows || [],
    expensesRows: data.expensesRows || [],
    cashRows: data.cashRows || [],
  };
}

  // First time load → create initial version
  const initial = {
    ...sheet,
    incomeRows: sheet.incomeRows || [],
    expensesRows: sheet.expensesRows || [],
    updatedAt: serverTimestamp(),
  };

  await setDoc(ref, initial);
  return initial;
}
